exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-icon-container{position:relative;display:inline-block;text-align:center;cursor:pointer;width:1.5rem;height:1.5rem;border-radius:50%;font-size:.75rem;box-sizing:content-box;color:var(--boy-blue)}.copy-icon-container:hover{background-color:var(--hover)}.copy-icon-container .copy-icon,.copy-icon-container .confirmation-icon{opacity:0;transition:150ms}.copy-icon-container .confirmation-icon{position:absolute;left:.375rem;top:.375rem}.copy-icon-container.copied .confirmation-icon{opacity:1}.copy-icon-container:not(.copied) .copy-icon{opacity:1}", ""]);

// exports
